import { Suspense, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import Container from '@/components/Container';
import useIsTablet from '@/hooks/useIsTablet';
import PageHeader from '@/components/PageHeader';
import { useResponsiveImage } from '@/utils/useResponsiveImage';
import { usePodcastList } from './hooks/usePodcastList';
import { usePodcastListStore } from './store/usePodcastListStore';
import { LatestPodcasts } from './components/latest';
import { PodcastListLoading } from './components/loading';
import { PodcastListenAt } from './components/listen-at';

const PodcastListPageContent = () => {
  const { isTablet } = useIsTablet();
  const { loading, loadMore, hasMore } = usePodcastList();
  const page = usePodcastListStore((state) => state.page);

  const pageTitle = page?.pageTitle;

  const heroImage = useMemo(
    () => ({
      url: page?.heroImage?.url || '',
      alternativeText: page?.heroImage?.alternativeText || '',
    }),
    [page?.heroImage],
  );

  const { src: heroImageSrc } = useResponsiveImage(heroImage, 'medium');

  return (
    <>
      <PageHeader
        title={pageTitle ?? 'Podcasts'}
        variant="media"
        mediaImageSrc={heroImageSrc}
        mediaImageAlt={heroImage.alternativeText}
        sideTitle={page?.heroTitle ?? null}
        sideDescription={page?.heroDescription ?? null}
        sideFooter={<PodcastListenAt label={page?.listenAtLabel} platforms={page?.platforms ?? null} />}
      />
      <Container className="!mt-sh-30 mt-sh-60 min-h-40" addMargin={!isTablet}>
        <div className="col-span-12 mt-[36px] md:mt-[0px]">
          <LatestPodcasts onLoadMore={loadMore} hasMore={hasMore} loading={loading} />
        </div>
      </Container>
    </>
  );
};

export const PodcastListPage = () => {
  const location = useLocation();

  return (
    <Suspense key={location.pathname} fallback={<PodcastListLoading />}>
      <PodcastListPageContent />
    </Suspense>
  );
};
